import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';

export const MIRAMARPRAPOSEDMITAC_LAYER_ID = 'miramarPraposedMITACLayer';

export const CATEGORY_COLORS = {
  MITAC: [118, 78, 159],
};

const layerConfig = {
  title: 'Proposed MITAC',
};

function MiramarPraposedMITACLayer() {
  const dispatch = useDispatch();
  const { miramarPraposedMITACLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, miramarPraposedMITACLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (miramarPraposedMITACLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: MIRAMARPRAPOSEDMITAC_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: miramarPraposedMITACLayer.visible,
      opacity: miramarPraposedMITACLayer.opacity,

      getFillColor: [118, 78, 159],
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: MIRAMARPRAPOSEDMITAC_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'Proposed MITAC',
              includeColumns: [
                'Development_Type',
                'Residential_Apartment_Units',
                'Residential_Townhome_Units',
                'Commercial_Area_Square_Feet',
                'Office_Area_Square_Feet',
              ],
            }),
          };
        }
      },
    });
  }
}

export default MiramarPraposedMITACLayer;
